// web_components/wcResubscribeModal/wcResubscribeModal_Renderer.ts

/**
 * Generates the HTML for the wc-resubscribe-modal component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <div id="${instanceId}" class="wc-resubscribe-modal modal-active modal-transition" role="dialog" aria-labelledby="resubscribeModalTitle" aria-describedby="resubscribeModalDescription" aria-modal="true" tabindex="-1">
        	<div class="wc-modal__overlay"><i></i></div>
            <div class="wc-modal__dialog">
				<button class="wc-modal__close" type="button" aria-label="Close modal"><i></i></button>
				<div class="wc-resubscribe-modal__container">
					<article>
						<h2 id="resubscribeModalTitle">${variables.resubscribeModalHeading}</h2>
						<p id="resubscribeModalDescription" class="wc-resubscribe-modal__description">
							${variables.resubscribeModalText}
						</p>
						<a class="wc-resubscribe-modal__btn" href="${variables.resubscribeModalCTAURL}" aria-label="Close resubscribe modal">${variables.resubscribeModalCTACopy}</a>
					</article>
					<div class="wc-resubscribe-modal__image"><i></i></div>
				</div>
            </div>
        </div>
    `;
}
